import { Grid, Skeleton } from '@mui/material';
import React from 'react';

const TableSkeletonLoader: React.FC = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Skeleton variant='rounded' sx={{ marginBottom: 1 }} width={'100%'} />
        <Skeleton variant='rounded' sx={{ marginBottom: 1 }} width={'100%'} />
        <Skeleton variant='rounded' sx={{ marginBottom: 1 }} width={'100%'} />
        <Skeleton variant='rounded' sx={{ marginBottom: 1 }} width={'100%'} />
        <Skeleton variant='rounded' sx={{ marginBottom: 1 }} width={'100%'} />
        <Skeleton variant='rounded' sx={{ marginBottom: 1 }} width={'100%'} />
        <Skeleton variant='rounded' sx={{ marginBottom: 1 }} width={'100%'} />
        <Skeleton variant='rounded' sx={{ marginBottom: 1 }} width={'100%'} />
      </Grid>
    </Grid>
  );
};

export default TableSkeletonLoader;
